import { AdminerContext } from './chunk-3G2YSMCN.js';
import { useContext } from 'react';

function useAdminer() {
  const ctx = useContext(AdminerContext);
  if (!ctx) {
    throw new Error(
      "useAdminer must be called inside <AdminerProvider>. Wrap your application with <AdminerProvider api={...}> at the root."
    );
  }
  return ctx;
}

// src/internal/slots/useSlot.ts
function useSlot(name) {
  return useAdminer().components[name];
}

// src/internal/permissions/useHasPermission.ts
function useHasPermission() {
  const { permissions } = useAdminer();
  return (permission) => permissions.has(null, permission);
}

export { useAdminer, useHasPermission, useSlot };
//# sourceMappingURL=chunk-MB2JPXXN.js.map
//# sourceMappingURL=chunk-MB2JPXXN.js.map